module.exports = __webpack_public_path__ + "img/logo-analytics.2bd5dd6c.jpg";